// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.

const radii = {
 "circle": "100px",
 "soft": "6px",
 "rounded": "3px",
 "hard": "0px"
}

export default radii;